const config = {
    language: "fi_FI",
    serverUrl: process.env.REACT_APP_API_URL
    //serverUrl: "https://gei5hfyx3l.execute-api.eu-north-1.amazonaws.com/dev", // DEV
    //serverUrl: "https://2e6i4snv1a.execute-api.eu-north-1.amazonaws.com/prod", // PROD
};

export default config;